<template>
  <div class="weChat__card--div">
    <a-card class="weChat__card" :bordered="false">
      <template slot="title">
        <span class="title__span">微信支付</span>
      </template>
      <div class="weChat__card__content">
        <p>
          <img :src="qrCodeImg" class="weChat__card_qrCodeImg" />
        </p>
        <div></div>
        <img :src="weChatImg" style="width: 40px; height: 40px;margin-right:16px" />
        <span class="weChat__card_span">使用微信扫码支付</span>
      </div>
    </a-card>
  </div>
</template>
<script>
export default {
  name: "weChatPay",
  data() {
    return {
      // qrCodeImg: require("@/assets/component/buy/qrCode.png"),
      qrCodeImg: this.$route.query.url,
      weChatImg: require("@/assets/component/buy/weChat.png"),
    };
  },
  mounted() {
    console.log(this.$route.query);
  },
  methods: {
    chooseVipLevel(id) {
      this.chooseVipLevelId = id;
    },
    chooseVipMonth(id) {
      this.chooseVipMonthId = id;
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>